import { baseApi } from 'api/api-base';
import camelcaseKeys from 'camelcase-keys';
import { API_ROUTES } from 'constants/api-routes';
import { GetFeatures } from 'types/api/api-features.types';

// Fetched once at login (App.tsx) — populates the `features` slice via extraReducers, which
// both the mining guard (default-visible) and the colo guard (opt-in) read from.
export const featuresApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getFeatures: builder.query<GetFeatures.ResponseType, GetFeatures.RequestType>({
      query: () => ({
        url: API_ROUTES.GET_FEATURES,
      }),
      extraOptions: {},
      transformResponse: (response: GetFeatures.RawApiResponse): GetFeatures.ResponseType =>
        camelcaseKeys(response as unknown as Record<string, unknown>, {
          deep: true,
        }) as GetFeatures.ResponseType,
    }),
  }),
});

export const { useGetFeaturesQuery } = featuresApi;
